module.exports = __webpack_public_path__ + "static/media/img_overpaper4@2x.4eb0be48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_overpaper4@2x.png
// module id = 969
// module chunks = 0